import {
	createContext,
	memo,
	useCallback,
	useContext,
	useMemo,
	useState,
} from 'react'
import { HELP_VIEWS } from '../utils/helpConstants'

const HelpCenterContext = createContext(null)

export function HelpCenterProvider({ children }) {
	const [open, setOpen] = useState(false)
	const [view, setView] = useState(HELP_VIEWS.HOME)
	const [activeCategoryId, setActiveCategoryId] = useState('all')
	const [searchQuery, setSearchQuery] = useState('')
	const [activeVideo, setActiveVideo] = useState(null)

	const openHelpCenter = useCallback((nextView = HELP_VIEWS.HOME) => {
		setView(nextView)
		setOpen(true)
	}, [])

	const closeHelpCenter = useCallback(() => {
		setOpen(false)
		setActiveVideo(null)
		setSearchQuery('')
		setActiveCategoryId('all')
		setView(HELP_VIEWS.HOME)
	}, [])

	const goHome = useCallback(() => {
		setView(HELP_VIEWS.HOME)
		setActiveCategoryId('all')
		setSearchQuery('')
	}, [])

	const openVideo = useCallback((video) => {
		setActiveVideo(video || null)
	}, [])

	const closeVideo = useCallback(() => {
		setActiveVideo(null)
	}, [])

	const value = useMemo(
		() => ({
			open,
			view,
			setView,
			activeCategoryId,
			setActiveCategoryId,
			searchQuery,
			setSearchQuery,
			activeVideo,
			openHelpCenter,
			closeHelpCenter,
			goHome,
			openVideo,
			closeVideo,
		}),
		[
			open,
			view,
			activeCategoryId,
			searchQuery,
			activeVideo,
			openHelpCenter,
			closeHelpCenter,
			goHome,
			openVideo,
			closeVideo,
		],
	)

	return (
		<HelpCenterContext.Provider value={value}>{children}</HelpCenterContext.Provider>
	)
}

export function useHelpCenter() {
	const ctx = useContext(HelpCenterContext)
	if (!ctx) {
		throw new Error('useHelpCenter must be used within HelpCenterProvider')
	}
	return ctx
}

export default memo(HelpCenterProvider)
